// extracted by mini-css-extract-plugin
export default {"root":"CustomBanner_root__20oDc","text":"CustomBanner_text__amF8W","link":"CustomBanner_link__EYcWr"};